import { render, staticRenderFns } from "./AddProjectChips.vue?vue&type=template&id=1fec9fdd&lang=pug"
import script from "./AddProjectChips.vue?vue&type=script&lang=js"
export * from "./AddProjectChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports